<template>
  <div>
    <div class="customers">
      <div>
          <p class="today-year-month">{{ todayYear }}年 {{ todayMonth }}月</p>
        </div>
      <div class="avatar" >
        <img v-bind:src="avatarImg" width="571" height="684" loding="lazy" />
      </div>
      <div class="float-right">
        <div class="customers-text-box">
          <div class="monitoring-alert body-weight-alert" v-show="!this.bodyWeightAlert">
            <img src="@/assets/home/アセット 26@2x.png"/>
          </div>
          <p class="customers-text text-base">体重</p>
          <span class="color-bule result-value">{{ this.hearingsLatest.weight }}</span>
          <p class="customers-text text-unit">kg</p>
        </div>
        <div class="customers-text-box">
          <div class="monitoring-alert stretch-alert" v-show="!this.stretchAlert">
            <img src="@/assets/home/アセット 26@2x.png"/>
          </div>
          <p class="customers-text text-base">屈伸</p>
          <span class="color-bule result-value">{{ this.hearingsLatest.stretch }}</span>
          <p class="customers-text text-unit">回</p>
        </div>
        <div class="customers-text-box">
          <div class="monitoring-alert health-check-alert" v-show="!this.healthCheckAlert">
            <img src="@/assets/home/アセット 26@2x.png"/>
          </div>
          <p class="customers-text text-base">健康チェック</p>
          <span class="color-bule result-value">{{ this.hearingsLatest.number_checked}}</span>
          <p class="customers-text text-unit">点</p>
        </div>
      </div>
      <div class="clear"></div>
    </div>
    <FrailCheckAlert v-if="hearingsLatestDialog" @home-back="closeAlert"/>
  </div>
</template>

<script>
import moment from "moment";
import FrailCheckAlert from "@/components/FrailCheckAlert";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
const UserRepository = RepositoryFactory.get("user");
const AccountRepository = RepositoryFactory.get("account");
const HearingsRepository = RepositoryFactory.get("hearings");
export default {
  name: "UserInformation",
  components: {
    FrailCheckAlert,
  },
  data() {
    return {
      hearingsLatest: "",
      todayYear: moment().format("YYYY"),
      todayMonth: moment().format("MM"),
      avatarImg: "",
      bodyWeightAlert: true,
      stretchAlert: true,
      healthCheckAlert: true,
      hearingsLatestDialog: false
    }
  },
  created() {
    // アクセストークンが有効期限きれかどうか判定する
    this.RefreshTokenUpdate()
  },
  async mounted () {
    this.$emit("handle-loading", true)
      const accountEndpoint = "part?gender=" + this.$store.state.users.gender;
      const healthDevStorage = "https://healthdevstorage.blob.core.windows.net/health/"

    await AccountRepository.get(accountEndpoint, this.$store.state.axiosHeaders)
      .then(response => this.avatarImg = response.data[0].avatar_img_path[0])
      .catch(error => {
        console.log(error)
        this.errored = true
      }).finally(() => {
        this.avatarImg = healthDevStorage + this.avatarImg
        });
        this.hearingLatestApi()
  },
  methods: {
    async RefreshTokenUpdate(){
      this.$store.state.axiosHeaders.access_token_expires_in = 1614566933; //有効期限切れトークン　検証時にコメントアウト外す
      // users.access_token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJsYXNoaWMiLCJleHAiOjE2NDA4NzY0MDAsInVzZXJfaWQiOiI3Nzc3In0.vzDNjvjXiM8f41xSU48-zI7VYEPXPbOpVlENvuHaWgg"
      let access_token_expires_in = new Date(this.$store.state.axiosHeaders.access_token_expires_in * 1000);
      let now = new Date();

      if (now > access_token_expires_in) {
        const UserEndpoint = "token/refresh";
        const body = {
          refresh_token: this.$store.state.axiosHeaders.refresh_token,
        };
        const config = {
          withCredentials: true,
        };
        await UserRepository.put(UserEndpoint, body, {config})
        .then(response => (this.res = response.data))
        .catch((error) => console.log(error))
        .finally(() => {
          const headers = {
            Authorization: "Bearer " + this.res.access_token,
            "Ocp-Apim-Subscription-Key": process.env.SUBSCRIPTION_KEY,
            access_token_expires_in: this.res.access_token_expires_in,
            refresh_token: this.res.refresh_token
            }
            this.$store.commit("FETCH_ADD_AXIOS_HEADERS", headers);
        })
      }
    },
    
    // 最新のヒアリング内容取得するAPI
    async hearingLatestApi() {
      const hearingAndpoint = "latest";
      await HearingsRepository.get(hearingAndpoint, this.$store.state.axiosHeaders)
      .then(response => (this.hearingsLatest = response.data))
      .catch(error => console.log(error))
      .finally(() => {
      this.$store.commit("FETCH_ADD_HEARINGS_DATE", this.hearingsLatest.date)
      this.hearingsLatestDateCheck()
      this.isHearingsAlertCheck()
      this.$emit("handle-loading", false)
      });
    },
    hearingsLatestDateCheck() {
      this.todayYear = this.hearingsLatest.date.split('-')[0]
      this.todayMonth = this.hearingsLatest.date.split('-')[1]

      if((this.todayYear === moment().format("YYYY")) && (this.todayMonth === moment().format("MM"))) {
        this.hearingsLatestDialog = false
      } else {
        this.hearingsLatestDialog = true
      }
    },
    isHearingsAlertCheck() {
      const bodyWeightCheck = 1
      const stretchCheck = 2
      const healthcheck = 3
      if(this.hearingsLatest.results[bodyWeightCheck]) this.bodyWeightAlert = true
      if(!this.hearingsLatest.results[bodyWeightCheck]) this.bodyWeightAlert = false
      if(this.hearingsLatest.results[stretchCheck]) this.stretchAlert = true
      if(!this.hearingsLatest.results[stretchCheck]) this.stretchAlert = false
      if(this.hearingsLatest.results[healthcheck]) this.healthCheckAlert = true
      if(!this.hearingsLatest.results[healthcheck]) this.healthCheckAlert = false
    },
    closeAlert() {
      this.hearingsLatestDialog = false
    }
  },
}
</script>

<style scoped>
  @import "../assets/css/user_information.css";
</style>



// WEBPACK FOOTER //
// src/components/UserInformation.vue